export default {
  companies: {
    icon: 'fa fa-calendar',
    title: ['Empresa', 'Empresas'],
    field: {
      id_text: 'Nome'
    }
  },
  services: {
    icon: 'fa fa-user',
    title: ['Serviço', 'Serviços'],
    field: {
      id: 'Código',
      identifier: 'Código',
      company_id: 'Empresa',
      id_text: 'Nome',
      category: 'Categoria',
      active: 'Ativo'
    }
  },
  anobase: {
    icon: 'fa fa-calendar',
    title: ['Ano Base', 'Anos Base'],
    field: {
      id: 'Código',
      id_texto: 'Ano',
      observacao: 'Observação'
    }
  },
  users: {
    icon: 'fa fa-user',
    title: ['Usuário', 'Usuários'],
    field: {
      id: 'Código',
      name: 'Nome',
      email: 'E-mail',
      acesso_interno: 'Acesso Interno',
      acesso_id: 'Acesso de Sistema'
    }
  },
  acesso: {
    icon: 'fa fa-user',
    title: ['Acesso', 'Acessos'],
    field: {
      id: 'Código',
      empresa_id: 'Empresa',
      id_texto: 'Nome',
      tipo: 'Tipo',
      descricao: 'Discriminação',
      permissoes: 'Permissões'
    }
  },
  pessoa: {
    icon: 'fa fa-user',
    title: ['Pessoa', 'Pessoas'],
    field: {
      id: 'Código',
      ultimo_numero_recibo: 'Último Número de Recibo',
      id_texto: 'Nome',
      nome_abreviado: 'Nome Abreviado',
      tipo: 'Tipo',
      cpf_cnpj: 'C.P.F.',
      rg_ie: 'RG/IE',
      cidade_id: 'Cidade',
      uf: 'UF',
      pais_id: 'País',
      endereco: 'Logradouro',
      numero: 'Número',
      bairro: 'Bairro',
      ativo: 'Ativo',
      observacao: 'Observação',
      nascimento: 'Data de Nascimento',
      titulo_eleitoral: 'Título Eleitoral',
      doenca_deficiencia: 'Possui doença ou deficiência física ou mental',
      possui_conjuge: 'Possui cônjuge',
      cpf_conjuge: 'CPF do cônjuge',
      natureza_ocupacao: 'Natureza da Ocupação',
      ocupacao_principal: 'Ocupação Principal',
      endereco_brasil: 'Endereço no Brasil',
      mudanca: 'Houve mudança no endereço',
      cpf_procurador: 'CPF do Procurador',
      tipo_logradouro: 'Tipo de Logradouro',
      cep: 'CEP / Código Postal',
      complemento: 'Complemento',
      ddd_ddi_telefone: 'DDD/DDI',
      telefone: 'Telefone',
      ddd_celular: 'DDD',
      celular: 'Celular',
      email: 'E-mail',
      codigo_ext: 'Código Exterior',
      cidade_ext: 'Cidade Exterior',
      pessoa_id: 'Cônjuge',
      empresa_id: 'Empresa Responsável'
    }
  },
  pessoa_contato: {
    icon: 'fa fa-user',
    title: ['Contato', 'Contatos'],
    field: {
      id: 'Código',
      id_texto: 'Contato',
      tipo: 'Tipo',
      pessoa_id: 'Nome'
    }
  },
  pessoa_dependente: {
    icon: 'fa fa-user',
    title: ['Dependente', 'Dependentes'],
    field: {
      id: 'Código',
      id_texto: 'Nome',
      tipo: 'Tipo',
      nascimento: 'Nascimento',
      cpf: 'C.P.F',
      pessoa_id: 'Pessoa',
      residencia_com_titular: 'Dependentemora com o titular da declaração?',
      e_mail: 'E-mail',
      telefone: 'Telefone',
    }
  },
  pessoa_empresa: {
    icon: 'fa fa-company',
    title: ['Empresa', 'Empresas'],
    field: {
      id: 'Código',
      empresa_id: 'Empresa',
      pessoa_id: 'Pessoa',
      ativo: 'Ativo'
    }
  },
  condominio: {
    icon: 'fa fa-fax',
    title: ['Condomínio', 'Condomínios'],
    field: {
      id: 'Código',
      id_texto: 'Nome',
      sigla: 'Sigla',
      razao_social: 'Razão Social',
      cpf: 'C.P.F.',
      cidade_id: 'Cidade',
      uf: 'UF',
      endereco: 'Endereço',
      pessoa_id: 'Responsável',
      ativo: 'Ativo'
    }
  },
  contribuinte: {
    icon: 'fa fa-fax',
    title: ['Contribuinte', 'Contribuintes'],
    field: {
      id: 'Código',
      id_texto: 'Nome',
      sigla: 'Sigla',
      razao_social: 'Razão Social',
      cpf: 'C.P.F.',
      cidade_id: 'Cidade',
      uf: 'UF',
      endereco: 'Endereço',
      pessoa_id: 'Responsável',
      ativo: 'Ativo'
    }
  },
  condominio_pessoa: {
    icon: 'fa fa-user',
    title: ['Sócio', 'Sócios'],
    field: {
      id: 'Código',
      porcentagem_inicial: 'Porcentagem Inicial',
      inicialporcentagem: 'Porcentagem Inicial',
      porcentagem: 'Porcentagem',
      data: 'Data',
      ativo: 'Ativo',
      pessoa_id: 'Sócio',
      condominio_id: 'Condomínio'
    }
  },
  condominio_quadrosocietario: {
    icon: 'switch_account',
    title: ['Quadro Societário', 'Quadros Societários'],
    field: {
      id: 'Código',
      data: 'Data',
      id_texto: 'Discriminação'
    }
  },
  condominio_bemdireito: {
    icon: 'fa fa-balance-scale',
    title: ['Bem e Direito', 'Bens e Direitos'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      grupo: 'Grupo',
      codigo: 'Código',
      sequencia_ir: 'Sequência IR',
      situacao_anobase: 'Situação em 31/12/',
      situacao_anoanterior: 'Situação em 31/12/',
      data: 'Data de Aquisição/Cadastramento',
      pais_id: 'Localização (País)',
      cei_cno: 'Inscrição CEI/CNO',
      ativo: 'Ativo',
      condominio_id: 'Codomínio',
      valor_pago: 'Pagamento/Acréscimo no Ano',
      valor_liberado: 'Alienação/Redução no Ano',
      pessoa_dependente_id: 'Dependente'
    }
  },
  condominio_bemdireito_item: {
    icon: 'fa fa-money',
    title: ['Bem e Direito Item', 'Bens e Direitos Itens'],
    field: {
      id: 'Código',
      tipo: 'Tipo',
      data: 'Data',
      valor: 'Valor'
    }
  },
  condominio_bemdireitorural: {
    icon: 'fa fa-leaf',
    title: ['Bem da Atividade Rural', 'Bens e Direitos Rurais'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      codigo: 'Código',
      sequencia_ir: 'Sequência IR',
      situacao_anobase: 'Situação em 31/12/',
      situacao_anoanterior: 'Situação em 31/12/',
      data: 'Data de Aquisição',
      pais_id: 'País',
      ativo: 'Ativo',
      motivo_baixa: 'Motivo da Baixa',
      nome_adquirente: 'Nome do Adquirente',
      condominio_id: 'Codomínio',
      baixa: 'Baixa',
      valor_pago: 'Pagamento/Acréscimo no Ano',
      valor_liberado: 'Alienação/Redução no Ano'
    }
  },
  condominio_bemdireitorural_item: {
    icon: 'fa fa-money',
    title: ['Bem da Atividade Rural Item', 'Bens e Direitos Rurais Itens'],
    field: {
      id: 'Código',
      tipo: 'Tipo',
      data: 'Data',
      valor: 'Valor'
    }
  },
  condominio_movimentacaofinanceira: {
    icon: ['fa fa-leaf'],
    title: ['Movimentação Financeira', 'Movimentações Financeiras'],
    field: {
      id: 'Código',
      mes_base: 'Mês',
      receita: 'Receita',
      despesa: 'Despesa',
      liberacao: 'Liberação',
      pagamento: 'Pagamento',
      condominio_id: 'Condomínio',
      anobase_id: 'Ano Base',
      resultado: 'Resultado'
    }
  },
  condominio_movimentacaorebanho: {
    icon: 'fa fa-plus',
    title: ['Movimentação Rebanho', 'Movimentações Rebanhos'],
    field: {
      id: 'Código',
      condominio_id: 'Condomínio',
      anobase_id: 'Ano Base',
      especie: 'Espécie',
      estoque_inicial: 'Estoque Inicial',
      aquisicao: 'Aquisições',
      nascimento: 'Nascimentos',
      consumo_e_perda: 'Consumo E Perdas',
      venda: 'Vendas',
      resultado: 'Resultado'
    }
  },
  condominio_bemdireito_anobase: {
    icon: 'fa fa-calculator',
    title: ['Situação Bem Direito', 'Situações Bem Direito'],
    field: {
      condominio_bemdireito_id: 'Bem Direito',
      anobase: 'Ano',
      situacao: 'Situação'
    }
  },
  condominio_dividaonus: {
    icon: 'fa fa-money',
    title: ['Dívida e Ônus Real', 'Dívidas e Ônus Reais'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      condominio_id: 'Dívida Ônus',
      codigo: 'Código',
      sequencia_ir: 'Sequência IR',
      data: 'Data de Cadastro',
      ativo: 'Ativo',
      banco: 'Credor',
      contrato: 'Contrato',
      contratacao: 'Contratação',
      vencimento: 'Vencimentos',
      valor_contrato: 'Valor Contrato',
      situacao_anobase: 'Situação em 31/12/',
      situacao_anoanterior: 'Situação em 31/12/',
      valor_pago: 'Pago Principal no Ano',
      valor_juros: 'Pago de Juros no Ano',
      total_geral: 'Total Geral no Ano',
      valor_liberado: 'Valor Liberado no Ano',
      condominio_pessoa_id: 'Responsável'
    }
  },
  condominio_dividaonus_item: {
    icon: 'fa fa-money',
    title: ['Dívida e Ônus Real Item', 'Dívidas e Ônus Reais Itens'],
    field: {
      id: 'Código',
      tipo: 'Tipo',
      data: 'Data',
      valor_base: 'Pago Principal',
      juros: 'Juros e Acessórios',
      valor_total: 'Valor Total'
    }
  },
  condominio_dividaonusrural: {
    icon: 'fa fa-tree',
    title: ['Dívida da Atividade Rural', 'Dívidas das Atividades Rurais'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      condominio_id: 'Dívida Ônus',
      codigo: 'Código',
      sequencia_ir: 'Sequência IR',
      data: 'Data de Cadastro',
      ativo: 'Ativo',
      banco: 'Credor',
      contrato: 'Contrato',
      propriedade: 'Propriedade',
      contratacao: 'Contratação',
      vencimento: 'Vencimentos',
      valor_contrato: 'Valor Contrato',
      situacao_anobase: 'Situação em 31/12/',
      situacao_anoanterior: 'Situação em 31/12/',
      valor_pago: 'Pago Principal no Ano',
      valor_juros: 'Pago de Juros no Ano',
      total_geral: 'Total Geral no Ano',
      valor_liberado: 'Valor Liberado no Ano',
      condominio_pessoa_id: 'Responsável'
    }
  },
  condominio_dividaonusrural_item: {
    icon: 'fa fa-money',
    title: ['Dívida e Ônus Real Item', 'Dívidas e Ônus Reais Itens'],
    field: {
      id: 'Código',
      tipo: 'Tipo',
      data: 'Data',
      valor_base: 'Pago Principal',
      juros: 'Juros e Acessórios',
      valor_total: 'Valor Total'
    }
  },
  condominio_imovelexplorado: {
    icon: 'fa fa-building',
    title: ['Imóvel Explorado', 'Imóveis Explorados'],
    field: {
      id: 'Código',
      id_texto: 'Discriminação',
      condominio_id: 'Condomínio',
      sequencia_ir: 'Sequência IR',
      atividade: 'Atividade',
      localizacao: 'Localização',
      nirf: 'CIB (NIRF)',
      area: 'Área',
      participacao: 'Participação (%)',
      exploracao: 'Exploração',
      cidade_id: 'Cidade',
      endereco: 'Logradouro',
      numero: 'Número',
      bairro: 'Bairro',
      cep: 'CEP / Código Postal',
      complemento: 'Complemento',
      caepf: 'C.A.E.P.F',
      inscr_estadual: 'Inscrição Estadual',
      tipo_exploracao: 'Tipo de Exploração',
      ativo: 'Ativo',
    }
  },
  condominio_imovelexplorado_terceiros: {
    icon: 'fa fa-users',
    title: ['Terceiro', 'Terceiros'],
    field: {
      id: 'Código',
      condominio_imovelexplorado_id: 'Imóvel Explorado',
      nome: 'Nome',
      cpf_cnpj: 'C.P.F./C.N.P.J.',
      tipo_participante: 'Tipo do Participante',
    }
  },
  condominio_pagamento: {
    icon: 'fa fa-dollar',
    title: ['Pagamento Efetuado', 'Pagamentos Efetuados'],
    field: {
      id: 'Código',
      condominio_id: 'Condomínio',
      codigo: 'Código',
      ano: 'Ano',
      sequencia_ir: 'Sequencia IR',
      beneficiario: 'Beneficiário',
      descricao: 'Discriminação',
      cpf_cnpj: 'C.P.F./C.N.P.J.',
      valor_pago: 'Valor Pago',
      anobase_id: 'Ano',
      pessoa_dependente_id: 'Dependente'
    }
  },

  condominio_pagamento_item: {
    icon: 'fa fa-money',
    title: ['Pagamento Efetuado Item', 'Pagamentos Efetuados Itens'],
    field: {
      id: 'Código',
      data: 'Data',
      valor: 'Valor'
    }
  },

  condominio_rendimentorecebidopj: {
    icon: 'fa fa-bar-chart',
    title: ['Rendimento Tributável Recebido de PJ', 'Rendimentos Tributáveis Recebidos de PJ'],
    field: {
      id: 'Código',
      id_texto: 'Fonte Pagadora',
      condominio_id: 'Condomínio',
      sequencia_ir: 'Sequência IR',
      cpf_cnpj: 'C.P.F./C.N.P.J.',
      anobase_id: 'Ano',
      pessoa_dependente_id: 'Dependente',
      valor_total: 'Valor Total'
    }
  },

  condominio_rendimentorecebidopj_item: {
    icon: 'fa fa-money',
    title: ['Rendimento Tributável Recebido de PJ Item', 'Rendimentos Tributáveis Recebidos de PJ Itens'],
    field: {
      id: 'Código',
      data: 'Data',
      recebido_pj: 'Rendimento Recebido de PJ',
      contribuicao_previdenciaria: 'Contribuição Previdenciária',
      imposto_retido: 'Imposto Retido na Fonte',
      salary_13: '13º Salário',
      irrf_salary_13: 'IRRF 13º Salário'
    }
  },

  condominio_rendimentoisento: {
    icon: 'fa fa-bar-chart',
    title: ['Rendimento Isento Não Tributável', 'Rendimentos Isentos Não Tributáveis'],
    field: {
      id: 'Código',
      id_texto: 'Fonte Pagadora',
      codigo: 'Código',
      condominio_id: 'Condomínio',
      sequencia_ir: 'Sequência IR',
      cnpj: 'C.P.F./C.N.P.J.',
      valor: 'Valor',
      anobase_id: 'Ano',
      valor_total: 'Valor Total',
      pessoa_dependente_id: 'Dependente',
      decimo_terceiro: '13º Salário',
      contribuicao_previdenciaria: 'Contribuição Previdenciária',
      irrf: 'IRRF',
      irrf_decimo_terceiro: 'IRRF 13º Salário',
    }
  },

  condominio_rendimentoisento_item: {
    icon: 'fa fa-money',
    title: ['Rendimento Isento Não Tributável Item', 'Rendimentos Isentos Não Tributáveis Itens'],
    field: {
      id: 'Código',
      data: 'Data',
      valor: 'Valor',
      rendimento: 'Rendimento',
      decimo_terceiro: '13º Salário',
      irrf: 'IRRF',
      irrf_decimo_terceiro: 'IRRF sobre o 13º',
      contribuicao_previdenciaria: 'Contribuição Previdenciária'
    }
  },

  condominio_rendimentotributacao: {
    icon: 'fa fa-bank',
    title: ['Rendimento Tributação Exclusiva', 'Rendimentos Tributações Exclusivas'],
    field: {
      id: 'Código',
      id_texto: 'Fonte Pagadora',
      codigo: 'Código',
      condominio_id: 'Condomínio',
      sequencia_ir: 'Sequência IR',
      cnpj: 'C.N.P.J.',
      valor: 'Valor',
      anobase_id: 'Ano',
      valor_total: 'Valor Total',
      pessoa_dependente_id: 'Dependente'
    }
  },

  condominio_rendimentotributacao_item: {
    icon: 'fa fa-money',
    title: ['Rendimento Tributação Exclusiva Item', 'Rendimentos Tributações Exclusivas Itens'],
    field: {
      id: 'Código',
      data: 'Data',
      valor: 'Valor'
    }
  },

  condominio_transacao: {
    icon: 'fa fa-bank',
    title: ['Transação', 'Transações'],
    field: {
      id: 'Código',
      data: 'Data',
      porcentagem: 'Porcentagem %',
      condominio_id: 'Condomínio',
      condominio_pessoa_id: 'Sócio'
    }
  },
  condominio_transacao_item: {
    icon: 'fa fa-bank',
    title: ['Transação Item', 'Transação Itens'],
    field: {
      id: 'Código',
      porcentagem: 'Porcentagem %',
      condominio_transacao_id: 'Transação',
      condominio_pessoa_id: 'Sócio'
    }
  },
  condominio_users: {
    icon: 'fa fa-user',
    title: ['Usuário', 'Usuários'],
    field: {
      id: 'Código',
      user_id: 'Usuário',
      acesso_id: 'Acesso',
      pessoa_id: 'Pessoa',
      condominio_id: 'Condomínio',
      ativo: 'Ativo'
    }
  },
  condominio_controlecaixa: {
    icon: 'menu_book',
    title: ['Controle de Caixa', 'Controles de Caixa'],
    field: {
      'id': 'ID',
      'data': 'Data',
      'codigo_imovel': 'Código do Imóvel',
      'codigo_conta': 'Código da Conta',
      'numero': 'Número do Documento',
      'tipo_documento': 'Tipo do Documento',
      'historico': 'Histórico',
      'cpf_cnpj': 'CPF/CNPJ',
      'tipo_lancamento': 'Tipo do Lançamento',
      'entrada': 'Entrada',
      'saida': 'Saída',
      'saldo_final': 'Saldo Final',
      'natureza': 'Natureza'
    }
  },
  accesses: {
    icon: 'lock',
    title: ['Acesso', 'Acessos'],
    field: {
      id_text: 'Nome',
      description: 'Discriminação',
      permissions: 'Permissões'
    }
  },
  permissions: {
    icon: 'lock',
    title: ['Permissão', 'Permissões'],
    field: {
      id_text: 'Nome',
      view: 'Visualizar',
      create: 'Criar',
      edit: 'Editar',
      destroy: 'Deletar'
    }
  },
  condominio_rendimentoacumuladamente: {
    icon: 'fa fa-bar-chart',
    title: ['Rendimento Recebido Acumuladamente', 'Rendimentos Recebidos Acumuladamente'],
    field: {
      condominio_id: 'Condomínio',
      anobase_id: 'Ano',
      registro_tipo: 'Tipo',
      forma_tributacao: 'Opção pela forma de tributação',
      cpf_cnpj_fonte_pagadora: ' da fonte pagadora',
      nome_fonte_pagadora: 'Nome da fonte pagadora',
      rendimentos_tributaveis: 'Rendimentos tributáveis',
      parcela_isenta_65_anos: 'Parcela isenta 65 anos',
      total_rendimentos: 'Total Rendimentos tributáveis',
      valor_recebido_juros: 'Valor recebido referente a juros',
      contribuicao_previdenciaria_oficial: 'Contribuição previdenciária oficial',
      imposto_retido_fonte: 'Imposto retido na fonte',
      mes_recebimento: 'Mês do recebimento',
      numero_meses: 'Número de meses',
      pessoa_dependente_id: 'Dependente'
    }
  },

  suporte: {
    icon: 'help_outline',
    title: ['Suporte', 'Suportes'],
    field: {
      id: 'ID',
      titulo: 'Título',
      descricao: 'Descrição',
      status: 'Status',
      tipo: 'Tipo',
      urgencia: 'Urgência',
      user_id: 'Usuário',
      imagem1: 'Imagem 1',
      imagem2: 'Imagem 2',
      imagem3: 'Imagem 3',
      imagem4: 'Imagem 4',
      imagem5: 'Imagem 5',
      created_at: 'Criado em',
    }
  }
}



// WEBPACK FOOTER //
// ./src/translate/pt_br/table.js